/* eslint-disable */
import React from 'react';

const DateReset = () => (
    <svg width="24" height="23" viewBox="0 0 24 23" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M12.8078 0C6.98623 0 2.52084 4.81539 1.99736 10.5374H0L2.85423 13.4822L5.96945 10.5374H3.94946C4.4488 5.66623 8.09353 1.54931 12.9059 1.54931C18.0532 1.54931 22.2425 5.90609 22.2425 11.26C22.2425 16.614 18.0532 20.9723 12.9059 20.9723C10.3489 20.9723 8.03017 19.8967 6.34358 18.1588L5.10503 19.4049C7.11597 21.3298 9.82538 22.5201 12.8078 22.5201C18.981 22.5201 24 17.4678 24 11.26C24 5.05224 18.981 0 12.8078 0Z" fill="#0D0D0D" />
        <path fill-rule="evenodd" clip-rule="evenodd" d="M11.9796 4.4407V11.9993H17.9532V10.4907H13.4444V4.4407H11.9796Z" fill="#0D0D0D" />
    </svg>
);

export default DateReset;
